export enum TaskStatus{
    COMPLETED="COMPLETED",
    PENDING = "PENDING",
    DUE = "DUE",
    INPROGRESS = "INPROGRESS",
    OVERDUE =  "OVERDUE"
}